import { Component, OnInit, AfterViewChecked, AfterViewInit, ElementRef, Renderer2, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AppConstants } from '../../shared/constants/constants';
import { AppMessages } from '../../shared/constants/messages';
import { CalendarModel } from '../../models/view-schedule/booking-detail.model';
import { DialogService } from '../../shared/services/dialog.service';
import { ViewScheduleService } from './view-schedule.service';
import { ShareService } from '../../shared/services/share.service';
import { BookingDetailsPopupComponent } from './booking-detail.component';

import * as moment from 'moment';
import { Appointment, PartyType } from '../../models/request-appointment/appointment.model';
import { Router, ActivatedRoute } from '@angular/router';
import { RequestAppointmentService } from '../request-appointment/request-appointment.service';
declare var $: any;
declare var pagescalendar: any;

@Component({
  selector: 'app-view-schedule',
  templateUrl: 'view-schedule.component.html',
  providers: [ViewScheduleService, RequestAppointmentService]
})
export class ViewScheduleComponent implements OnInit, AfterViewInit, OnDestroy {
  public timeslot = AppConstants.calendar.timeslot;
  public bookingInfo = new CalendarModel();
  public bookingCacheDetail: any = null;
  public showDeactiveMessage = true;
  public timeRange = null;
  public rendered = false;
  public showBack = false;
  public centreData = [];
  public centreId = null;
  public isCalendarRendered = false;
  public notificationRef;
  //public centreIdDetal = null;
  constructor(private router: Router, private rd: Renderer2,
    private el: ElementRef,
    private activeRouter: ActivatedRoute,
    private dialogService: DialogService,
    private shareService: ShareService,
    private viewScheduleService: ViewScheduleService,
    private requestAppointmentService: RequestAppointmentService
  ) {

  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.bookingCacheDetail != null && this.showDeactiveMessage !== false) {
      const confirmMessage = AppMessages.booking.discardConfirm;
      return this.dialogService.openConfirmationDialog({ message: confirmMessage }).flatMap(
        result => {
            if (result) {
                return this.requestAppointmentService.deleteBookingCache().map(
                    success => {
                        if (success) {
                            return true;
                        }
                        return false;
                });
            } else {
                return Observable.of(false);
            }
        });
    } else {
      return true;
    }
  }

  ngOnInit() {
    this.centreId = this.activeRouter.snapshot.params['id'] || null;
    // get all active centre
    this.viewScheduleService.getAllCentre().subscribe(
      result => {
        if (result) {
          this.centreData = result.json();
          if (this.centreData.length > 0 && this.centreId === null) {
            this.centreId = this.centreData[0].id;
            this.renderCalendar();
          } else if (this.centreId !== null) {
            this.viewScheduleService.getBookingCache(this.centreId).subscribe(
              (result1) => {
                if (result1) {
                  const data = result1.json();
                  if (data !== null && data !== undefined) {
                    this.bookingCacheDetail = data;
                    this.centreId =  this.bookingCacheDetail['centreId'];
                    this.showBack = true;
                    this.renderNotification();
                    this.renderCalendar();
                  }
                }
              }
            );
          }
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.notificationRef) {
      this.notificationRef.close();
    }
  }

  renderCalendar() {
    if (!this.isCalendarRendered && this.centreId) {
      this.isCalendarRendered = true;
      this.getBookingList(true);
    }
  }

  getBookingList(isInitCalendar = false) {
    if (this.timeRange == null) {
      this.timeRange = this.getCurrentWeek();
    }
    const param = {
      timeRange: this.timeRange,
      centreId: this.centreId
    };
    this.viewScheduleService.getBookingList(param).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.updateBookingListData(data);
        if (isInitCalendar) {
          this.initCalendar(this.bookingInfo);
        } else {
          $('#myCalendar').pagescalendar('removeAllEvents');
          $('#myCalendar').pagescalendar('addEvents', this.bookingInfo.bookingList);
        }
      }
    });
  }

  updateBookingListData(data) {
    this.bookingInfo.bookingList = this.shareService.convertBookingListToLocalTime(data.bookingList);
    this.bookingInfo.disableDates = this.shareService.convertBookingDisableDateToLocalTime(data.disableDates);
  }

  ngAfterViewInit() {
    this.renderCalendar();
  }

  initCalendar(bookingInfo) {
    let selectedEvent;
    let self = this;
    $('#myCalendar').pagescalendar({
      ui: {
        // Year Selector
        year: {
          visible: true,
          format: 'YYYY',
          startYear: (new Date()).getFullYear() - 2,
          endYear: moment().add(1, 'year').format('YYYY'),
          eventBubble: true
        },
        // Month Selector
        month: {
          visible: true,
          format: 'MMM',
          eventBubble: true
        },
        dateHeader: {
          format: 'dddd, D MMMM YYYY', //'MMMM YYYY, D dddd',
          visible: true,
        },
        //Mini Week Day Selector
        week: {
          day: {
            format: 'D'
          },
          header: {
            format: 'dd'
          },
          eventBubble: true,
          startOfTheWeek: '0',
          endOfTheWeek: '6',
          visible: true
        },
        //Week view Grid Options
        grid: {
          dateFormat: 'D dddd',
          timeFormat: 'h A',
          eventBubble: true,
          scrollToFirstEvent: false,
          scrollToAnimationSpeed: 300,
          scrollToGap: 20
        }
      },
      events: bookingInfo.bookingList,
      view: 'week',
      timeFormat: 'h:mm A',
      slotDuration: '5', // 5 minutes per slot
      disableDates: bookingInfo.disableDates,
      disableTimes: bookingInfo.disableTimes,
      onDateChange: function (range, updateViewFunction) {
        const time = {
          startTime: self.shareService.convertBookingDateToUTCString(range.start._d),
          endTime: self.shareService.convertBookingDateToUTCString(moment(range.end._d).hour(23).minute(59).second(59))
        };
        // if dateTime is in the same week then no need to reload data
        if (time.startTime === self.timeRange.startTime) {
          return;
        }
        self.timeRange = time;
        const param = {
          timeRange:  self.timeRange,
          centreId: self.centreId
        };
        self.viewScheduleService.getBookingList(param).subscribe(
            (result) => {
                if (result) {
                     const data = result.json();
                   //  self.bookingInfo = data;
                     this.events = data.bookingList;
                     self.updateBookingListData(data);
                     this.disableDates = self.bookingInfo.disableDates;
                  //   this.disableTimes = data.disableTimes;
                  //   self.bookingInfo.disableDates = data.disableDates;
                  //   self.bookingInfo.disableTimes = data.disableTimes;
                     if ( updateViewFunction && typeof ( updateViewFunction ) === 'function' ) {
                         updateViewFunction();
                     }
                }
            }
        );
      },
      onEventClick: function (event, updateViewFunction) {
        if (event.class !== 'Block') {
          // if item is flu detail in flu vaccine booking then open Flu Booking detail
          self.onOpenBookingDetail(event).subscribe(
            result => {
              const index = parseInt(event.index, 0);
              if (typeof result === 'object') {
                result = self.shareService.convertBookingItemToLocalTime(result);
                this.events[index] = result;
                if (updateViewFunction && typeof (updateViewFunction) === 'function') {
                  updateViewFunction();
                }
              } else if (result === true) {
                // event was delete then remove from event list
                this.events.splice(index, 1);
                if (updateViewFunction && typeof (updateViewFunction) === 'function') {
                  updateViewFunction();
                }
              }
            }
          );
        }
      },
      onEventDragStart: function (event) {
      },
      onEventDragComplete: function (event, newEvent, element, callbackFunction) {
        if ($(element).parent().hasClass('disable')) {
          callbackFunction(event, false);
          return;
        }
        // return true when update success, else return false
        selectedEvent = event;
        const confirmMessage = AppMessages.booking.changeDate;
        self.dialogService.openConfirmationDialog({ message: confirmMessage }).subscribe(result => {
          if (result) {
            const data = {
              startTime: self.shareService.convertBookingDateToUTCString(newEvent.start),
              endTime: self.shareService.convertBookingDateToUTCString(newEvent.end)
            };
            const id = self.bookingInfo.bookingList[newEvent.index].id;
            // call API to update this event
            self.viewScheduleService.changeTimeBooking(id, data).subscribe(
              result1 => {
                  if (callbackFunction && typeof (callbackFunction) === 'function') {
                      callbackFunction(event, result1);
                  }
              },
              err => {
                  if (callbackFunction && typeof (callbackFunction) === 'function') {
                      callbackFunction(event, false);
                  }
              }
          );

          } else {
            if (callbackFunction && typeof (callbackFunction) === 'function') {
              callbackFunction(event, false);
            }
          }
        });
      },
      onTimeSlotDblClick: function (obj, timeSlot) {
        if (self.bookingCacheDetail == null) {
          return;
        }
        const confirmMessage = AppMessages.booking.bookingConfirm;
        self.dialogService.openConfirmationDialog({ message: confirmMessage }).subscribe(
          confirm => {
            if (confirm) {
              self.bookingCacheDetail['startTime'] = self.shareService.convertBookingDateToUTCString(timeSlot.date);
              self.viewScheduleService.addBooking(self.bookingCacheDetail).subscribe(
                result => {
                  if (result) {
                    const data = result.json();
                    // Adding a new Event on Slot Double Click when API success
                    let newEvent = data.result;
                    newEvent = self.shareService.convertBookingItemToLocalTime(newEvent);
                  //  self.bookingInfo.bookingList.push(newEvent);
                    newEvent['index'] = this.events.length - 1;
                    self.dialogService.openSuccessDialog({ message: data.message.message });
                    selectedEvent = newEvent;
                    $('#myCalendar').pagescalendar('addEvent', newEvent);
                    self.bookingInfo.bookingList = this.events;
                    // reset  self.bookingCacheDetail
                    self.bookingCacheDetail = null;
                    self.showBack = false;
                  }
                }
                // error =>{
                //     self.dialogService.openErrorDialog({message : error.message})
                // }
              );
            }
          });
      },
      onViewRenderComplete: function() {
      }
    });
  }

  renderNotification() {
    if (this.showBack === true) {
      this.notificationRef = this.dialogService.openNotificationDialog({ message:  AppMessages.flu.notification});
    }
  }

  onOpenBookingDetail(item): Observable<any> {
    const data = {
      id: this.bookingInfo.bookingList[item.index].id,
      isGroup: this.bookingInfo.bookingList[item.index].bookingType == PartyType.Group
    };
    const dialogRef = this.dialogService.openComponentDialog(BookingDetailsPopupComponent, data, { 'width': '900px' });
    return dialogRef;
  }

  getCurrentWeek() {
    const currentDay = moment().hour(0).minute(0).second(0).format('YYYY-MM-DDTHH:mm:ss');
    const dayNum = moment(currentDay).day();
    return {
        startTime: this.shareService.convertBookingDateToUTCString(moment(currentDay).add('days', -dayNum)),
        endTime: this.shareService.convertBookingDateToUTCString(moment(currentDay).add('days', (6 - dayNum)).hour(23).minute(59).second(59))
    };
  }

  onBack() {
    this.showDeactiveMessage = false;
    this.router.navigate(['request-appointment', this.centreId]);
  }

  onChangeCentre(event) {
    this.centreId = event.target.value;
    this.getBookingList(false);
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-schedule/view-schedule.component.ts